<template>
	<div class="ding-table-module">
		<!-- Status Tab -->
		<div class="mx-4 mt-4 mb-3">
			<div class="booking-table-tab booking-table-tab-unapproved" @click="currentBookingType = 'ongoing'" :class="{active: currentBookingType == 'ongoing'}">
				{{$t('ongoing_bookings_tab')}}
			</div>
			<div class="booking-table-tab booking-table-tab-approved" @click="currentBookingType = 'past'" :class="{active: currentBookingType == 'past'}">{{$t('past_bookings_tab')}}</div>
		</div>
		<!-- End Status Tab -->
		<div :class="{ 'content-wrapper': openedByTrackOrder }">
			<div v-if="bookings.length === 0 && !isLoadingBooking" class="mt-4 text-center text-muted">{{$t(currentBookingType === 'ongoing' ? 'no_ongoing_bookings' : 'no_past_bookings')}}</div>

			<loading-indicator :full-parent="openedByTrackOrder" :clear-background="true" :is-loading="true" v-else-if="isLoadingBooking" class="mt-2 text-center"/>

			<div v-else>
				<div v-if="paging && bookings.length > 0" class="text-right paging-information mx-3">
					<span v-if="this.paging.total == -1">
					{{$t('bookingTable.loading_bookings')}}
					</span>
					<span v-else>
					{{$t('bookingTable.paging_information_entry', this.paging)}}
					</span>
					<span v-if="this.paging.totalPage > 0">
						{{$t('bookingTable.paging_information_page', this.paging)}}
					</span>
				</div>
				<div v-if="paging && bookings.length > 0" class="text-right mx-3">
					<span class="previous-page-button" :class="{disabled: this.paging.total == -1 || this.paging.current == 1}" @click="() => {(paging.total == -1 || paging.current == 1) ? '' : loadBookings(paging.current - 1)}"></span>
					<span class="next-page-button" :class="{disabled: this.paging.total == -1 ||  this.paging.total == 0 || this.paging.current == this.paging.totalPage}" @click="() => {(paging.total == -1 ||  paging.total == 0 || paging.current == paging.totalPage) ? '' : loadBookings(paging.current + 1)}"></span>
				</div>
				<table class="w-100 ding-table" border=0>
					<thead>
						<th>{{$t('booking_id')}}</th>
						<th>{{$t('booking_content')}}</th>
						<th v-if="isDesktop">{{$t('booking_payment')}}</th>
						<th v-if="!openedByTrackOrder">{{$t('status')}}</th>
					</thead>
					<tbody>
						<tr v-for="b in processedBookings" :key="b.id" class="cursor-pointer" @click="selectedBooking = b" @click.stop="openBookingChecked(b)">
							<td>
								<div v-if="!isDesktop && acceptingPayment(b) && hasPendingPayment(b)" class="mt-1"><div class="label label-tight label-danger text-center my-1" style="line-height: 1.2;">{{$t('payments.status_PENDING')}}</div></div>
								<div>{{b.display_id}}</div>

								<template v-if="openedByTrackOrder">
									<div	
										v-if="isBookingOverdue(b) && b.status.toLowerCase() === 'unapproved'"
										v-b-tooltip.hover
										class="mt-1 customer-label muted"
										:id="'booking-tooltip-target-' + b.id">
										{{$t('booking.has_past_no_reply')}}</div>
									<div v-else class="mt-1 customer-label" :class="getLabelClassForBooking(b)">
										{{$t('provider.booking_status_' + b.status.toLowerCase())}}
									</div>
								</template>
							</td>
							<td>
								<div class="break">
									<span>{{b.display_datetime}}</span>
									<br v-if="openedByTrackOrder" />
									<span><b>{{b.member_user.name}}</b></span>
									<br v-if="openedByTrackOrder" />
									<span>{{b.service.title}}</span>
								</div>
								<label v-if="b.customer_booking_pass?.booking_pass">
									{{ b.customer_booking_pass.booking_pass.title }}
								</label>
							</td>
							<td v-if="isDesktop">
								<span v-if="b.payments.length == 0"></span>
								<span v-if="acceptingPayment(b) && hasPendingPayment(b)" class="click-to-pay btn btn-sm btn-primary">{{$t('click_to_pay')}}</span>
								<div v-for="p in b.payments" :key="p.id" class="payment-item mt-1" :class="getPaymentClassForPayment(p)">
									{{p.item_title}}
									<span v-if="p.original_currency">{{ localizedAmount(p.original_amount, p.original_currency)}}</span>
									<span v-else>{{ localizedAmount(p.amount, p.settled_currency)}}</span>
								</div>
							</td>
							<td v-if="!openedByTrackOrder">
								<div
									v-if="isBookingOverdue(b) && b.status.toLowerCase() === 'unapproved'"
									v-b-tooltip.hover
									class="mt-1 customer-label muted"
									:id="'booking-tooltip-target-' + b.id">
									{{$t('booking.has_past_no_reply')}}</div>
								<div v-else class="mt-1 customer-label" :class="getLabelClassForBooking(b)">
									{{$t('provider.booking_status_' + b.status.toLowerCase())}}
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div v-if="paging && bookings.length > 0" class="text-right mx-3">
					<span class="previous-page-button" :class="{disabled: this.paging.total == -1 || this.paging.current == 1}" @click="() => {(paging.total == -1 || paging.current == 1) ? '' : loadBookings(paging.current - 1)}"></span>
					<span class="next-page-button" :class="{disabled: this.paging.total == -1 ||  this.paging.total == 0 || this.paging.current == this.paging.totalPage}" @click="() => {(paging.total == -1 ||  paging.total == 0 || paging.current == paging.totalPage) ? '' : loadBookings(paging.current + 1)}"></span>
				</div>
				<div v-if="paging && bookings.length > 0" class="text-right paging-information mx-3 mb-2">
					<span v-if="this.paging.total == -1">
					{{$t('bookingTable.loading_bookings')}}
					</span>
					<span v-else>
					{{$t('bookingTable.paging_information_entry', this.paging)}}
					</span>
					<span v-if="this.paging.totalPage > 0">
						{{$t('bookingTable.paging_information_page', this.paging)}}
					</span>
				</div>
			</div>
		</div>
		<customer-booking-checker v-if="bookingToCheck" ref="bookingChecker" :context="context" :provider="provider" @close="bookingToCheck = null" />
	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import displayBooking from '../mixins/display-booking.js';
import loadingIndicator from './common/LoadingIndicator.vue';
import CustomerBookingChecker from './landing/CustomerBookingChecker.vue';
import moment from 'moment';
import { localizedAmount } from '../currency.js';
import api from '../bu/api';
import promptConfirm from '../mixins/prompt-confirm';

export default {
	mixins: [displayBooking, promptConfirm],
	components: { loadingIndicator, CustomerBookingChecker },
	props: {
		context: {type: Object, required: true},
		provider: {type: Object, required: true},
		guestBookingsArgs: {type: Object, required: false},
	},
	computed: {
		...mapGetters({
			customer: 'app/customer',
			bookings: 'customer/bookings',
			paging: 'customer/bookingPagination',
			currency: 'currencies/currency',
			currencyRateMap: 'currencies/currencyRateMap',
			currencyOptions: 'currencies/currencyOptions',
		}),
		processedBookings() {
			var bookings = [].concat(this.bookings);
			this.processBookings(this.provider, bookings);
			return bookings;
		},
		hasLogInEnabled() {
			return !!(this.provider.login_setting && this.provider.login_setting.enabled);
		},
		openedByTrackOrder() {
			return !!(this.guestBookingsArgs &&  this.guestBookingsArgs.email && this.guestBookingsArgs.phoneNumber && this.guestBookingsArgs.phoneCallingCode);
		},
		isDesktop() {
			return window.innerWidth >= 425;
		}
	},
	mounted() {
		this.loadBookings(0);
		this.context.bus.$on('booking-saved', this.bookingSaved);
	},
	beforeDestroy() {
		this.context.bus.$off('booking-saved', this.bookingSaved);
	},
	data() {
		return {
			currentBookingType: 'ongoing', //ongoing, past
			page: 0,
			selectedBooking: null,
			isLoadingBooking: false,
			newlySavedBooking: null,
			bookingToCheck: null
		}
	},
	watch: {
		currentBookingType() {
			this.loadBookings(0)
		}
	},
	methods: {
		localizedAmount,
		...mapActions({
			getLoggedInCustomer: 'app/getLoggedInCustomer',
			logOutCustomer: 'app/logOutCustomer',
			getBookings: 'customer/getBookings',
			getGuestBookings: 'customer/getGuestBookings'
		}),
		acceptingPayment(booking) {
			return booking.status === 'unapproved' || booking.status === 'approved';
		},
		openBookingChecked(booking) {
			this.bookingToCheck = booking;
			this.$nextTick(() => {
				this.$refs['bookingChecker'].setDisplayIdToCheck(booking.display_id);
			})
		},
		hasPendingPayment(booking) {
			return booking.payments.filter((p) => p.status === 'PENDING').length > 0
		},
		async loadBookings(page) {
			this.isLoadingBooking = true;
			if (this.openedByTrackOrder) {
				try {
					await this.getGuestBookings({
						phoneCallingCode: this.guestBookingsArgs.phoneCallingCode,
						phoneNumber: this.guestBookingsArgs.phoneNumber,
						email: this.guestBookingsArgs.email,
						page,
						type: this.currentBookingType
					});
				}
				catch (e) {
					this.$emit('error');
				}
			} else if(this.hasLogInEnabled){
				// ongoing OR past
				await this.getBookings({ page, type: this.currentBookingType });
			}
			this.isLoadingBooking = false;
		},
		getPaymentClassForPayment(payment) {

		},
		getLabelClassForBooking(booking) {
			if (booking.status.toLowerCase() === 'approved') {
				return 'approved';
			} else if (booking.status.toLowerCase() === 'unapproved') {
				return 'unapproved';
			}
			return 'muted';
		},
		isBookingOverdue(booking) {
			return moment(booking.start_datetime).isBefore(moment());
		},
		showBookingDetails(booking) {
			this.$emit('show-booking-details', booking);
		}
	}
}
</script>

<style lang="scss" scoped>
.full-page {
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	overflow: auto;
	z-index: 3000;
	background: white;
}

::-webkit-scrollbar {
	display: none;
}

.customer-tab {
	background: #eee;
	width: 100%;
	display: flex;
	flex-direction: row;
	font-size: 12px;

	.customer-tab-item {
		flex-grow: 1;
		text-align: center;
		padding: 16px 32px;
		cursor: pointer;

		&.tab-item-active {
			background: white !important;
		}

		&:hover {
			background: #e8e8e8;
		}

	}
}
	.booking-table-tab {
		font-size: 12px;
		display: inline-flex;
		background: transparent;
		padding: 8px 16px;
		color: #90A4AE;
		border: 1px solid transparent;
	}

	.booking-table-tab.active, .booking-table-tab:hover {
		border-radius: 24px;
		background: white;
		cursor: pointer;
		color: #F5C51E;
		border: 1px solid #F5C51E;
	}

	.content-wrapper{
		overflow: auto;
		min-height: 30vh;
		max-height: 60vh;
	}

	.ding-table {
		padding: 0px 8px;
	}

	tr {
		background: #F6F6F6 !important;
		border-radius: 0 !important;

		td {
			border-radius: 0 !important;
		}
	}

	.break {
		word-break: break-word;
		white-space: normal;
	}
.ding-table-module {
	font-size: 16px;
	.previous-page-button {
		background: url('/img/left@2x.png');
		background-repeat: no-repeat;
		background-size: contain;
		width: 25px;
		height: 25px;
		display: inline-block;
		cursor: pointer;
		opacity: 0.8;
	}

	.next-page-button {
		background: url('/img/right@2x.png');
		background-repeat: no-repeat;
		background-size: contain;
		width: 25px;
		height: 25px;
		display: inline-block;
		cursor: pointer;
		opacity: 0.8;
		margin-left: 10px;
	}

	.previous-page-button:hover, .next-page-button:hover {
		opacity: 1;
	}

	.previous-page-button.disabled, .next-page-button.disabled {
		opacity: 0.25;
		cursor: not-allowed;
	}

	.click-to-pay {
		font-size: 12px;
		border-radius: 3px;
		background-color: #F1BB6A;
	}
}

.customer-label {
	min-width: 70px;
	text-align: center;
	padding: 3px 8px;
	display: inline-block;
	border-radius: 3px;

	&.unapproved {
		border: 1px solid #F1BB6A;
		color: #F1BB6A;
	}

	&.approved {
		border: 1px solid #89DC8E;
		color: #89DC8E;
	}

	&.muted {
		border: 1px solid #969696;
		color: #969696;
	}
}
	.paging-information {
		font-size: 12px;
		margin: 4px 0px;
		color: #90A4AE;
	}
</style>

<i18n>
{
	"en": {
		"no_ongoing_bookings": "No Ongoing Bookings",
		"no_past_bookings": "No Past Bookings",
		"booking_id": "Booking ID",
		"booking_content": "Service",
		"booking_payment": "Payments",
		"status": "Status",
		"ongoing_bookings_tab": "Ongoing",
		"past_bookings_tab": "Past",
		"click_to_pay": "Click to pay",
		"no_payment_yet": "None",
		"book_again": "Book Again"
	},
	"zh": {
		"no_ongoing_bookings": "無目前預約",
		"no_past_bookings": "無過往預約",
		"no_bookings": "尚無資料",
		"booking_id": "預約編號",
		"booking_content": "預約內容",
		"booking_payment": "款項",
		"status": "狀態",
		"ongoing_bookings_tab": "目前預約",
		"past_bookings_tab": "過往預約",
		"click_to_pay": "點此付款",
		"no_payment_yet": "無",
		"book_again": "再次預約"
	}
}
</i18n>